import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';

export const failureModePaths = {
    '/api/surveys/{surveyId}/failureModes/copy': {
        parameters: [createPathGuidParameter('surveyId')],
        post: {
            operationId: 'failureModeControllers.copy',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                id: Type.String(),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            failureModeId: Type.String(),
                            manifestationId: Type.String(),
                        }),
                    },
                },
            },
        },
    },
} as const;
